import DataModel from '../../common/model/DataModel';

export default class AggregableSummaryDataModel extends DataModel {
  constructor(preferenceGroupName) {
    super();

    this.preferenceGroupName = preferenceGroupName;
  }

  onPropertyUpdated(propertyName, oldValue, newValue) {
    switch (propertyName) {
      default:
        break;
    }
  }
}